import { render, staticRenderFns } from "./schoolIndex.vue?vue&type=template&id=435cccd8&scoped=true&"
import script from "./schoolIndex.vue?vue&type=script&lang=js&"
export * from "./schoolIndex.vue?vue&type=script&lang=js&"
import style0 from "./schoolIndex.vue?vue&type=style&index=0&id=435cccd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435cccd8",
  null
  
)

export default component.exports